import {
  type BookSize,
  fallbackUntilMatch,
  getPageTier,
  hashTilePricingProduct,
  MAX_PHOTO_BOOK_PAGES,
  MIN_PHOTO_BOOK_PAGES,
  type PageTier,
  type PricingProduct,
  type TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import clamp from 'lodash/clamp'
import { type PricingItem } from '../../components/Pricing/types/pricingItem.types'
// A designed or AI cover moves the cover photo into the pages, so a full book
// holds one page over the max.
export const MAX_PRICED_BOOK_PAGES = MAX_PHOTO_BOOK_PAGES + 1

// The bag also quotes books still under the minimum, which can't be ordered
// yet, so they price as the smallest book that can. Books past
// MAX_PRICED_BOOK_PAGES, restored from when books held up to 300 photos, quote
// the top tier while the bag blocks their checkout.
export function getBookPageTier(pageCount: number): PageTier {
  return getPageTier(
    clamp(pageCount, MIN_PHOTO_BOOK_PAGES, MAX_PHOTO_BOOK_PAGES)
  )
}

export function getBookPricingProduct({
  bookSize,
  pageCount,
  isPriceTierEnabled,
}: {
  bookSize: BookSize
  pageCount: number
  isPriceTierEnabled: boolean
}): PricingProduct {
  return {
    tileSize: bookSize as unknown as TILE_SIZES,
    ...(isPriceTierEnabled && { pageTier: getBookPageTier(pageCount) }),
  }
}

// Variants without tier prices have only the plain size doc, which the
// fallback reaches by dropping pageTier.
export function getBookTierPrice(
  pricingItems: Record<string, PricingItem>,
  bookSize: BookSize,
  pageTier: PageTier
): number | undefined {
  return fallbackUntilMatch(
    { tileSize: bookSize as unknown as TILE_SIZES, pageTier },
    (pricingProduct): PricingItem | undefined =>
      pricingItems[hashTilePricingProduct(pricingProduct)]
  )?.price
}
